// extracted by mini-css-extract-plugin
export default {"secondaryColor":"style_secondaryColor__+d3lj","primaryColor":"style_primaryColor__2v6HH","fontSize":"style_fontSize__mdTYL"};